import * as React from 'react';
import { WithCommonProps } from '@types';
import { getFieldInputStylesAsClassName } from '../field-styles';
import { twMerge } from 'tailwind-merge';

export interface IFieldInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Flag to indicate whether the input has an invalid value */
  isInvalid?: boolean;
  /** Indicate if the label should be visible */
  showLabel?: boolean;
  /** Tab index html attribute */
  tabIndex?: number;
}

export type FieldInputProps = WithCommonProps<IFieldInputProps>;

export const FieldInput = React.forwardRef(
  (
    props: FieldInputProps,
    ref: React.ForwardedRef<HTMLInputElement>
  ): JSX.Element => {
    const {
      name,
      isInvalid = false,
      showLabel = true,
      disabled = false,
      readOnly = false,
      dataId,
      className: classNameProp,
      ...rest
    } = props;

    const twClassName = twMerge(
      getFieldInputStylesAsClassName(isInvalid, showLabel, disabled, readOnly),
      classNameProp
    );
    return (
      <input
        name={name}
        id={name}
        ref={ref}
        readOnly={readOnly}
        disabled={disabled}
        aria-invalid={isInvalid || undefined}
        className={twClassName}
        data-id={dataId}
        {...rest}
      />
    );
  }
);

FieldInput.displayName = 'FieldInput';
